import { render, staticRenderFns } from "./DetailsPane.vue?vue&type=template&id=1d219893&scoped=true&"
import script from "./DetailsPane.vue?vue&type=script&lang=ts&"
export * from "./DetailsPane.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsPane.vue?vue&type=style&index=0&id=1d219893&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d219893",
  null
  
)

export default component.exports